import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import SignInPage from './pages/auth/SignInPage'
import SignUpPage from './pages/auth/SignUpPage'
import AcceptInvitationPage from './pages/auth/AcceptInvitationPage'
import MainApp from './components/MainApp'
import LoadingSpinner from './components/common/LoadingSpinner'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

function AppRoutes() {
  const { user, isAuthenticated, isLoading } = useAuth()

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      {/* Authentication pages */}
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
      
      {/* Root redirects based on auth status */}
      <Route path="/" element={
        isAuthenticated ? (
          <Navigate to="/dashboard" replace />
        ) : (
          <Navigate to="/signin" replace />
        )
      } />
      
      {/* Protected routes */}
      <Route path="/dashboard" element={
        isAuthenticated ? (
          <MainApp user={user} initialTab="campaigns" />
        ) : (
          <Navigate to="/signin" replace />
        )
      } />
      
      <Route path="/settings" element={
        isAuthenticated ? (
          <MainApp user={user} initialTab="settings" />
        ) : (
          <Navigate to="/signin" replace />
        )
      } />
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
